import { render, staticRenderFns } from "./balance_modal.vue?vue&type=template&id=1a6f51c2"
import script from "./balance_modal.vue?vue&type=script&lang=js"
export * from "./balance_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports